const config = {
  useSystemColorMode: false,
  initialColorMode: 'dark',
}

export default config;